import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";
import { Loader2 } from "lucide-react";

export default function AdminLogin() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "radial-gradient(ellipse at center, #121210 0%, #060605 100%)" }}>
      <form onSubmit={submit} className="cs-fadein" style={{ width: "min(380px, 92vw)", background: "rgba(16,16,14,0.95)", border: "1px solid var(--cs-border)", padding: "40px 34px" }}>
        <div className="cs-mono" style={{ fontSize: 10, color: "var(--cs-mute)", marginBottom: 8 }}>KURATOR-TERMINAL</div>
        <h1 className="cs-heading" style={{ fontSize: 20, color: "var(--cs-bone)", marginBottom: 30 }}>COGNITIVE SPACE</h1>
        <label className="cs-mono" style={label}>E-MAIL</label>
        <input data-testid="admin-passcode-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="cs-input" style={input} autoComplete="username" />
        <label className="cs-mono" style={label}>PASSWORT</label>
        <input data-testid="admin-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="cs-input" style={input} autoComplete="current-password" />
        {error && <div data-testid="admin-login-error" className="cs-mono" style={{ fontSize: 11, color: "var(--cs-crimson)", marginBottom: 16 }}>{error}</div>}
        <button data-testid="admin-login-submit-btn" type="submit" disabled={loading} className="cs-btn" style={{ width: "100%", padding: 14, background: "var(--cs-bone)", color: "#0A0A09", border: "none", cursor: "pointer", opacity: loading ? 0.6 : 1 }}>
          {loading ? <Loader2 size={13} className="animate-spin" style={{ display: "inline" }} /> : "Betreten"}
        </button>
      </form>
    </div>
  );
}

const label = { display: "block", fontSize: 9, color: "var(--cs-mute)", marginBottom: 8 };
const input = { width: "100%", padding: "12px 14px", fontSize: 14, marginBottom: 20 };
